import { render, staticRenderFns } from "./SwiperCube.vue?vue&type=template&id=2b010d50&"
import script from "./SwiperCube.vue?vue&type=script&lang=js&"
export * from "./SwiperCube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports